<template>
  <section class="time-line" ref="timelineContainer" id="Timeline">
    <!-- For now this is the quickest way to fix the issue that the timeline should remain sticky -->
    <Background :isTimeline="true" />
    <!-- <div
      :class="[
        { hide: y >= 0 },
        'time-line__fixed-title',
        'time-line__decades',
      ]"
    >
      <h2 class="time-line__decades__title">
        {{ content.title }}
      </h2>

      <transition name="fade">
        <div
          v-if="$tvaMq === 'mobile' && y < -2"
          class="time-line__fixed-title__year"
        >
          {{ $t("general.years") }}
        </div>
      </transition>
    </div> -->

    <div
      class="time-line__decades"
      id="wrapper"
      :key="route.query.category"
      ref="wrapperTimeline"
    >
      <!-- <RightAnchors :anchors="anchors" /> -->
      <h2 class="time-line__decades__title">
        {{ content.title }}
      </h2>

      <DecadeSection
        v-for="(decade, index) in currentDecades"
        :key="index"
        :decade="decade"
        :index="index"
        :anchor="dataStore.getAnchors[index]"
        :anchors="dataStore.getAnchors"
        :containerTop="y"
        :containerHeight="height"
      />

      <!-- @anchorInView="setDecadeInUrl"
        @removeAnchorFromView="removeAnchorFromView" -->

      <!-- :containerScrollY="y" -->
    </div>
    <Filters
      :class="{ 'fix-filters': y < footerThreshold, 'hidden-filters': y + height < footerThreshold * 2}"
      :filterContent="content.filters"
    />
  </section>
</template>

<script setup>
import Filters from "./Filters/Filters.vue";
import DecadeSection from "./DecadeSection.vue";
import Background from "@/components/Landing/Background.vue";
import { useDataStore } from "../../utilities/stores/data";
import { nextTick, onMounted, ref, computed, watch } from "vue";
import { useElementBounding } from "@vueuse/core";
import { useRoute } from "vue-router";
// import RightAnchors from "./RightAnchors.vue";

defineProps({
  content: Object,
});

// const router = useRouter();
const route = useRoute();
const timelineContainer = ref(null);
const wrapperTimeline = ref(null);
const dataStore = useDataStore();
const footerThreshold = window.innerHeight * 0.5;
// const anchorsInView = ref([]);

const { y, height } = useElementBounding(timelineContainer);

const currentDecades = computed(() => {
  if (route.query.category) {
    return dataStore.getDecades.filter((decade) =>
      decade.some(
        (year) => year.CATEGORY.toLowerCase() === route.query.category
      )
    );
  }

  return dataStore.getDecades;
});

function scrollToElement(element) {
  const yOffset = -108;
  const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

  // document.getElementById(value).scrollIntoView({ behavior: "smooth" });

  window.scrollTo({ top: y, behavior: "smooth" });
}

onMounted(() => {
  if (route.query.decade) {
    const el = document.getElementById(route.query.decade);

    if (el) {
      nextTick(() => scrollToElement(el));
    }
  }
});

watch(
  () => route.query.disposition,
  () => {
    if (route.query.decade) {
      const el = document.getElementById(route.query.decade);

      if (el) {
        nextTick(() => scrollToElement(el));
      }
    }
  }
);

// /**
//  * Set query param in url to anchor, if the anchor newly scrolled into view
//  */
// function setDecadeInUrl(anchor) {
//   if (
//     !anchorsInView.value.includes(anchor) &&
//     (!route.query.decade || route.query.decade != anchor)
//   ) {
//     anchorsInView.value.push(anchor);
//     router.push({ query: { ...route.query, decade: anchor } });
//   }
// }

// /**
//  * Remove anchor from anchors in view and set query param to last shown anchor
//  */
// function removeAnchorFromView(anchor) {
//   anchorsInView.value = anchorsInView.value.filter((a) => a != anchor);

//   if (anchorsInView.value.length != 0) {
//     router.push({
//       query: {
//         ...route.query,
//         decade: anchorsInView.value[anchorsInView.value.length - 1],
//       },
//     });
//   }
// }
</script>

<style lang="scss" scoped>
@keyframes bounce {
  0% {
    transform: translateY(0px);
  }
  30% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(0px);
  }
  90% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0px);
  }
}

.animate {
  animation: bounce 1.5s alternate;
}
.time-line {
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: 6rem;
  // .tablet &,
  // .desktop &,
  // .large & {
  //   height: calc(var(--vh, 1vh) * 100);
  // }

  &__fixed-title {
    position: fixed;
    left: 0;
    top: 0rem;
    width: 100%;
    background-color: $scala-grigi-white;
    z-index: 2;
    padding-top: 1rem;
    transform: translateY(0);
    transition: transform 0.5s;

    &.hide {
      opacity: 0;
      pointer-events: none;
      max-height: 0;
      max-width: 0;
      transform: translateY(-1rem);
    }

    &__year {
      @include link-m;

      position: absolute;
      top: calc(6.1vh + 1.25rem);
      right: 1.5rem;
      color: $scala-grigi-gray_2;
    }
  }

  &__decades {
    //   .tablet &,
    // .desktop &,
    // .large & {
    //   max-height: calc(var(--vh, 1vh) * 100 - $filter-height);
    //   overflow: scroll;
    // }

    &__title {
      align-self: start;
      width: fit-content;
      padding: 6.1vh 0px 1vh 8.26vw;
      color: $scala-grigi-gray-1;
      @include title-h-1;
    }
  }

  .fix-filters {
    @keyframes slide-in {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }

    position: fixed;
    bottom: 0;
    right: 0;
    animation: slide-in 0.7s;
  }
  .hidden-filters {
    @keyframes slide-out {
      from {
        transform: translateY(0%);
      }
      to {
        transform: translateY(100%);
      }
    }

    position: fixed;
    bottom: 0;
    right: 0;
    transform: translateY(100%);
    animation: slide-out 0.7s;
  }
}
</style>
